import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import Icon from '@/components/base/Icon';

export const PreviewTiktokBusiness = ({ post, isLoading }) => {
    const { t } = useTranslation('commons');

    if (isLoading) {
        return (
            <span className="square block animate-pulse rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
        );
    }

    if (post?.medias?.[0]?.no_analytics) {
        return (
            <div
                className="relative flex w-full flex-col overflow-hidden rounded-md bg-icoGray-100 p-4 dark:bg-icoDarkMode-deepBlack lg:p-16"
                aria-label="preview-tiktok">
                <div className="square">
                    <div className="flex flex-col items-center justify-center rounded-md">
                        <Icon
                            className="text-xl text-icoGray-500 dark:text-icoDarkMode-wolf"
                            icon="play"
                        />
                        <p className="mt-4 text-center text-sm text-icoGray-500 dark:text-icoDarkMode-wolf">
                            {t('media_viewer.tiktok_no_analytics')}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div
            className="relative mb-8 flex w-full flex-col items-center overflow-hidden rounded-md bg-icoGray-100 p-4 dark:bg-icoDarkMode-deepBlack lg:p-10"
            aria-label="preview-tiktok-business">
            <iframe
                className="rounded-lg"
                title="preview-tiktok"
                height={500}
                width={400}
                src={post?.medias?.[0]?.video}
                allow="autoplay;"
            />
        </div>
    );
};
